// extracted by mini-css-extract-plugin
export default {"login":"LoginPage_login__aZRB8","loginBtn":"LoginPage_loginBtn__XiDZv"};